import React, { useEffect, useState, Suspense } from "react";
const LazyHelper = ({ children, fallback }) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    return (React.createElement(React.Fragment, null, mounted ? React.createElement(Suspense, { fallback: fallback }, children) : fallback));
};
export default LazyHelper;
